var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3999 0.499878C1.0999 0.799879 0.899902 1.29988 0.899902 1.89988V24C0.899902 24.6 1.0999 25.1 1.3999 25.4L1.4999 25.5L13.8999 13.0999V12.9999V12.8999L1.3999 0.499878Z",
    fill: "url(#paint0_linear_1772_4363)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 17.2999L13.8999 13.2V13.0001V12.9001L17.9999 8.80017L18.0999 8.90017L22.9999 11.7001C24.3999 12.5001 24.3999 13.8 22.9999 14.6L17.9999 17.2999Z",
    fill: "url(#paint1_linear_1772_4363)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0999 17.2001L13.8999 13.0001L1.3999 25.5C1.8999 26 2.5999 26 3.4999 25.6L18.0999 17.2001Z",
    fill: "url(#paint2_linear_1772_4363)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0999 8.79987L3.4999 0.499868C2.5999 -0.000132352 1.8999 0.0998681 1.3999 0.599869L13.8999 12.9999L18.0999 8.79987Z",
    fill: "url(#paint3_linear_1772_4363)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.9999 17.1L3.4999 25.3001C2.6999 25.8001 1.9999 25.7001 1.4999 25.3001L1.3999 25.4001L1.4999 25.5001C1.9999 25.9001 2.6999 26.0001 3.4999 25.5001L17.9999 17.1Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.4 25.3C1.1 25 1 24.5 1 23.9V24C1 24.6 1.2 25.1 1.5 25.4V25.3H1.4Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23 14.3001L18 17.1L18.1 17.2L23 14.4001C23.7 14.0001 24 13.5001 24 13.0001C24 13.5001 23.6 13.9001 23 14.3001Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.5 0.599884L23 11.7C23.6 12.1 24 12.5 24 13C24 12.5 23.7 12 23 11.6L3.5 0.499883C2.1 -0.300125 1 0.399882 1 1.9999V2.0999C1 0.499883 2.1 -0.200123 3.5 0.599884Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_4363",
    x1: 12.7996,
    y1: 1.70958,
    x2: -3.98288,
    y2: 18.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_4363",
    x1: 24.8343,
    y1: 13.0015,
    x2: 0.63739,
    y2: 13.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1772_4363",
    x1: 15.8269,
    y1: 15.2962,
    x2: -6.93118,
    y2: 38.0545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1772_4363",
    x1: -1.7028,
    y1: -6.82394,
    x2: 8.45981,
    y2: 3.33857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.3c0d1915.svg";
export { ForwardRef as ReactComponent };